<script setup>
import { reactive, ref, useTemplateRef } from 'vue'
import * as v from 'valibot'
import { useStoryblokStore } from '@/stores/storyblok'

import cardsImg from '../assets/hero-styles/cards.jpeg'
import centeredImg from '../assets/hero-styles/centered.jpeg'
import offsetImg from '../assets/hero-styles/offset.jpeg'
import splitImg from '../assets/hero-styles/split.jpeg'

import gridDialogImg from '../assets/testimonials-styles/grid-dialog-bubble.jpeg'
import gridAvatarsImg from '../assets/testimonials-styles/grid-large-avatar.jpeg'
import sliderTeftLeftImg from '../assets/testimonials-styles/slider-text-left.jpeg'
import sliderAvatarsImg from '../assets/testimonials-styles/slider-large-avatar.jpeg'

const storyblokStore = useStoryblokStore()

const showTestimonials = ref(false)
const heroBannerItems = ref([
  {
    label: 'Cards',
    value: 'cards',
    image: cardsImg,
  },
  {
    label: 'Centered',
    value: 'centered',
    image: centeredImg,
  },
  {
    label: 'Offset',
    value: 'offset',
    image: offsetImg,
  },
  {
    label: 'Split',
    value: 'split',
    image: splitImg,
  },
])

const testimonialsItems = ref([
  {
    label: 'Grid with dialog bubbles',
    value: 'grid-dialog-bubble',
    image: gridDialogImg,
  },
  {
    label: 'Grid with large avatars',
    value: 'grid-large-avatar',
    image: gridAvatarsImg,
  },
  {
    label: 'Slider with text on the left',
    value: 'slider-text-left',
    image: sliderTeftLeftImg,
  },
  {
    label: 'Slider with large avatars',
    value: 'slider-large-avatar',
    image: sliderAvatarsImg,
  },
])

const HeroBannerSchema = v.object({
  heroTemplate: v.string('You must select a template'),
})

const TestimonialSchema = v.object({
  testimonialsTemplate: v.string('You must select a template'),
})

const heroBannerState = reactive({
  heroTemplate: storyblokStore.heroBannerTemplate || null,
})
const testimonialState = reactive({
  testimonialsTemplate: storyblokStore.testimonialsTemplate || null,
})

const form = useTemplateRef('form')
defineExpose({
  async validate() {
    const validData = await form.value.validate()
    if (validData) {
      if (showTestimonials.value) {
        storyblokStore.testimonialsTemplate = validData.testimonialsTemplate
        return true
      } else {
        storyblokStore.heroBannerTemplate = validData.heroTemplate
        showTestimonials.value = true
      }
    }
    return false
  },
})
</script>

<template>
  <h2 class="text-primary text-3xl mb-8">
    {{ showTestimonials ? 'Template for Testimonials' : 'Template for Hero Banner' }}
  </h2>
  <UForm
    v-if="!showTestimonials"
    ref="form"
    :schema="HeroBannerSchema"
    :state="heroBannerState"
    class="w-fit space-y-6"
  >
    <UFormField name="heroTemplate">
      <URadioGroup
        legend="Select the template to use for the homepage's hero banner:"
        v-model="heroBannerState.heroTemplate"
        variant="card"
        color="secondary"
        :items="heroBannerItems"
        :ui="{ legend: 'mb-4' }"
      >
        <template #label="{ item }">
          <span class="block mb-2">{{ item.label }} style</span>
          <img :src="item.image" :alt="`${item.label} style`" />
        </template>
      </URadioGroup>
    </UFormField>
  </UForm>
  <UForm
    v-if="showTestimonials"
    ref="form"
    :schema="TestimonialSchema"
    :state="testimonialState"
    class="w-fit space-y-6"
  >
    <UFormField name="testimonialsTemplate">
      <URadioGroup
        legend="Select the template to use for the homepage's testimonials section:"
        v-model="testimonialState.testimonialsTemplate"
        variant="card"
        color="secondary"
        :items="testimonialsItems"
        :ui="{ legend: 'mb-4' }"
      >
        <template #label="{ item }">
          <span class="block mb-2">{{ item.label }} style</span>
          <img :src="item.image" :alt="`${item.label} style`" />
        </template>
      </URadioGroup>
    </UFormField>
  </UForm>
</template>
